import { useState } from 'react';
import { ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from '@mui/material';
import CompGroupsDialog from 'pages/Valuations/components/CompGroups/components/CompGroupsDialog';
import { PRIVATE_TRANSACTIONS } from 'pages/Valuations/util/constants';
import { CompGroupsOptionsProps } from './CompGroupsOptions.props';
import { compGroupsOptionsClasses, CompGroupsOptionsRoot } from './CompGroupsOptions.styles';

const CompGroupsOptions = ({
  setOpenCompGroupsOptions,
  compGroupsRef,
  openCompGroupsOptions,
  saveCompGroups,
  deleteCompGroup,
  tableData,
  approachType,
}: CompGroupsOptionsProps) => {
  const [openCompGroupsDialog, setOpenCompGroupsDialog] = useState(false);

  const handleMenuItemClick = () => {
    setOpenCompGroupsOptions(false);
    setOpenCompGroupsDialog(true);
  };

  const handleClose = () => {
    setOpenCompGroupsOptions(false);
  };

  const compGroupType = approachType === PRIVATE_TRANSACTIONS ? 'Transaction' : 'Public';
  const optionsCompGroups = [
    {
      value: 0,
      title: `Select ${compGroupType} Comps Group`,
    },
  ];

  return (
    <CompGroupsOptionsRoot>
      <Popper
        open={openCompGroupsOptions}
        anchorEl={compGroupsRef.current}
        role={undefined}
        transition
        disablePortal
        placement="top-end"
        style={{ zIndex: 1300 }}>
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper className={compGroupsOptionsClasses.paper}>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" className={compGroupsOptionsClasses.menuList}>
                  {optionsCompGroups.map((option, index) => (
                    <MenuItem
                      id={`comp-groups-options-btn-${index}`}
                      key={`${option.title}-${option.value}}`}
                      className={compGroupsOptionsClasses.menuItem}
                      onClick={() => handleMenuItemClick()}>
                      {option.title}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
      <CompGroupsDialog
        openCompGroupsDialog={openCompGroupsDialog}
        setOpenCompGroupsDialog={setOpenCompGroupsDialog}
        saveCompGroups={saveCompGroups}
        deleteCompGroup={deleteCompGroup}
        tableData={tableData}
        approachType={approachType}
      />
    </CompGroupsOptionsRoot>
  );
};

export default CompGroupsOptions;
